import { getStore } from '../store/Store';
import { mutatorAction } from 'satcheljs';

/**
 * Mutator to reset the searchText and suggestionPill.
 */
export default mutatorAction('clearSearchBox', function clearSearchBox() {
    const store = getStore();
    store.suggestionPill = null;
    store.searchText = '';
});
